module.exports = __webpack_public_path__ + "media/components/country-flag/static/pw-7b9f4f30c17603c5a05ccf3eb464c00d.svg";